import { createContext } from 'react';

import { ILocomotiveScrollContext } from './locomotiveScroll.types';

export const LocomotiveScrollContext = createContext<ILocomotiveScrollContext>({
	scroll: null,
	isReady: false,
});
